import React from 'react';

const PageLoadingSpinner = () => (
  <div
    id="page-loading-spinner"
    role="status"
    aria-live="polite"
    aria-atomic="true"
    className="d-flex justify-content-center align-items-center"
    style={{ minHeight: '200px' }}
  >
    <div className="spinner-border" aria-hidden="true" />
    <span className="visually-hidden">Seite wird geladen…</span>
  </div>
);

export default PageLoadingSpinner;
